import {
  UseFormHandleSubmit,
  UseFormRegister,
  UseFormWatch,
  UseFormSetValue,
  FieldErrors,
  FieldValues,
  UseFormGetValues,
} from "react-hook-form";
import BasicInfo from "../tabs/BasicInfo";
import IdentifierTab from "../tabs/IdentifiedTab";
import ShowcaseTab from "../tabs/ShowcaseTab";
import AccountTab from "../tabs/AccountTab";
import PrivacyTab from "../tabs/PrivacyTab";
import SettingsTab from "../tabs/SettingsTab";
import { RegionType } from "../useUserProfile";
import { TabType } from "../ProfileEditModal";

type PassField = "password" | "newPassword" | "confirmPassword" | null;

interface Props {
  activeTab: TabType;
  hasUnsavedChanges: boolean;
  register: UseFormRegister<any>;
  watch: UseFormWatch<any>;
  setValue: UseFormSetValue<any>;
  errors: FieldErrors;
  regions: RegionType[];
  openPassField: PassField;
  togglePasswordVisibility: (f: Exclude<PassField, null>) => void;
  handleSubmit: UseFormHandleSubmit<any>;
  onSubmit: (d: any) => void;
  getValues: UseFormGetValues<FieldValues>;
  teamList: string[];
}

export default function ProfileForm({
  activeTab,
  hasUnsavedChanges,
  register,
  watch,
  setValue,
  errors,
  regions,
  openPassField,
  togglePasswordVisibility,
  handleSubmit,
  onSubmit,
  getValues,
  teamList,
}: Props) {
  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      className="cabinet_profileeditmodal-right"
    >
      {activeTab === "basic" && (
        <BasicInfo
          register={register}
          watch={watch}
          setValue={setValue}
          regions={regions}
          hasUnsavedChanges={hasUnsavedChanges}
          errors={errors}
        />
      )}
      {activeTab === "identifier" && <IdentifierTab watch={watch} />}
      {activeTab === "showcase" && (
        <ShowcaseTab
          teamList={teamList}
          getValues={getValues}
          register={register}
          watch={watch}
          hasUnsavedChanges={hasUnsavedChanges}
          setValue={setValue}
        />
      )}
      {activeTab === "account" && (
        <AccountTab
          openField={openPassField}
          toggle={togglePasswordVisibility}
          register={register}
          errors={errors}
          hasUnsavedChanges={hasUnsavedChanges}
          watch={watch}
        />
      )}
      {activeTab === "privacy" && (
        <PrivacyTab
          setValue={setValue}
          hasUnsavedChanges={hasUnsavedChanges}
          watch={watch}
        />
      )}
      {activeTab === "settings" && <SettingsTab />}
    </form>
  );
}
